import { usageId } from "../../constants/usageid.js";
import { ResellerSchemaIds, ResellerTags } from "../../schemas/reseller.const.js";
export const dictionary = {
    schema: {
        // [ResellerSchemaIds_deprecated.RESELLER]: {
        //   title: 'Reseller organisation',
        //   description:
        //     'An reseller organisation that manages a collection of domains.',
        // },
        // [ResellerSchemaIds_deprecated.RESELLER_LIST]: {
        //   title: 'List of resellers organisations',
        //   description: 'A list of reseller organisations.',
        // },
        // [ResellerSchemaIds_deprecated.RESELLER_FILTER]: {
        //   title: 'Reseller organisation filter',
        //   description: 'Collection of optional values where to filter on.',
        // },
        // [ResellerSchemaIds_deprecated.CREATE_RESELLER]: {
        //   title: 'Reseller organisation name and title',
        //   description: 'The name and title for a new reseller organisation.',
        // },
        // [ResellerSchemaIds_deprecated.UPDATE_RESELLER]: {
        //   title: 'Reseller organisation properties to update',
        //   description:
        //     'Collection of optional properties to update on a reseller organisation.',
        // },
        [usageId(ResellerSchemaIds.RESELLER, ResellerTags.DEFAULT)]: {
            title: 'Reseller organisation',
            description: 'A reseller organisation that manages a collection of atlases.',
        },
    },
};
